import './styles.css';
import { api } from './api';
import { h, mount, toast } from './dom';
import { session, type Screen } from './session';
import { loginScreen } from './ui/login';
import { lobbyScreen } from './ui/lobby';
import { gameRoute, trainingScreen } from './ui/gameRoute';
import { profileScreen } from './ui/profile';
import { soundsScreen } from './ui/soundsPage';
import { socket } from './ws';
import { initNotifications } from './notifications';

// Při nasazení nové verze se staré chunky smažou – při chybě importu obnovit stránku
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

const root = document.getElementById('app')!;
let current: Screen | null = null;
let routeToken = 0;
let checkedSession = false;

function show(screen: Screen) {
  current?.destroy();
  current = screen;
  mount(root, screen.el);
}

async function route() {
  const token = ++routeToken;
  const path = location.hash.replace(/^#/, '') || '/';
  if (!checkedSession) {
    try {
      const r = await api.me();
      session.me = r.user;
      session.registration = r.registration;
      session.look = r.look;
      session.isAdmin = r.isAdmin;
      checkedSession = true;
    } catch (e) {
      mount(root, h('div', { class: 'login backdrop' }, h('div', { class: 'card' }, (e as Error).message, h('button', { onclick: () => route() }, 'Zkusit znovu'))));
      setTimeout(() => token === routeToken && route(), 2000);
      return;
    }
    if (token !== routeToken) return;
  }
  if (!session.me) {
    socket.disconnect();
    show(loginScreen(path === '/login' ? '/' : path, route));
    return;
  }
  socket.connect();
  initNotifications();

  const [, section, arg] = path.split('/');
  if (section === 'game' && arg) {
    const screen = await gameRoute(decodeURIComponent(arg));
    if (token !== routeToken) return screen?.destroy();
    if (screen) show(screen);
    return;
  }
  if (section === 'training') {
    socket.setGame(null);
    show(trainingScreen());
    return;
  }
  // Nastavení zvuku vidí každý, knihovnu upravují jen správci
  if (section === 'sounds') {
    socket.setGame(null);
    show(soundsScreen());
    return;
  }
  if (section === 'player' && arg) {
    show(profileScreen(decodeURIComponent(arg)));
    return;
  }
  if (section === 'join' && arg) {
    try {
      const { game } = await api.join(decodeURIComponent(arg));
      if (token === routeToken) location.replace(`#/game/${game.id}`);
    } catch (e) {
      toast((e as Error).message, true);
      if (token === routeToken) location.replace('#/');
    }
    return;
  }
  show(lobbyScreen());
}

window.addEventListener('hashchange', route);
route();
